export default __webpack_public_path__ + "static/media/Access-Health-Support_580x340.e18c0258.jpg";